import { observer } from "mobx-react-lite";
import { FC, useEffect } from "react";
import { isMobile } from "react-device-detect";
import homeStore from "../store/homeStore";
import ProductCardCarousel from "../../../components/ProductCardCarousel";

const PopularNow: FC = () => {
  useEffect(() => {}, []);

  return (
    <div className="flex flex-col gap-[10px]">
      <h2 className=" text-[20px] md:text-[27px] tracking-[-0.02em] font-bold">
        Популярно сейчас
      </h2>
      <div className="w-full md:h-full">
        <ProductCardCarousel
          isMobile={isMobile}
          sliderClassName={
            "md:bg-white md:rounded-[15px] relative md:shadow-[0px_2px_20px_10px_rgba(0,0,0,0.10)] " +
            (isMobile ? "!overflow-visible" : "")
          }
          products={homeStore.popularNow}
          showMobilePagination
          desktopNavigationClassName="after:text-black after:text-xl"
          mobileSlideClassName="!w-[200px] !h-auto"
          desktopSlideClassName="border-r-1 border-r-[#54545657] last:border-r-0 !h-auto !w-[246px]"
          skeletonCountMobile={2}
          skeletonCountDesktop={5}
        />
      </div>
    </div>
  );
};

export default observer(PopularNow);
